/* Gravitational constant (m³/(kg·s²)) */
export const G = 6.67430e-11;

/** Orbit compression factor (1:10⁹) */
export const ORBIT_SCALE = 1e-9;

/** Visual planet size multiplier */
export const VISUAL_PLANET_MULT = 230000;

/** Fixed physics timestep (s) */
export const FIXED_DT = 1 / 60;

/** Standard gravity (m/s²) — used for Isp mass flow calc */
export const G0 = 9.80665;

/** Extended burn time for powered transfers against the stronger Earth gravity.
 * Fuel consumption and displayed delta-v use this same multiplier. */
export const FUEL_FLOW_MULT = 1 / 20;

/** Playable Earth radius and mass: 2.5× radius, 18 m/s² at sea level. */
export const EARTH_RADIUS = 6.371e6 * 2.5;
export const EARTH_MASS = 18 * EARTH_RADIUS ** 2 / G;

/** Visual part scale factor (rocket size relative to planets) */
export const PART_SCALE = 0.05;

/** Rocket visual scale multiplier */
export const ROCKET_VISUAL_SCALE = 60;

/** Terrain displacement fraction of visual radius */
export const TERRAIN_DISP_FRAC = 0.001;

/** Ocean depression */
export const TERRAIN_OCEAN_FRAC = 0;

/** Sea level threshold */
export const TERRAIN_SEA_LEVEL = 0.35;

/** Resolve asset URL with correct base path for GitHub Pages. */
export function assetUrl(path: string): string {
  const base = (import.meta as any).env?.BASE_URL ?? '/';
  return (base + path.replace(/^\//, '')).replace(/\/\//g, '/');
}
